/* eslint camelcase: 0 */
import { getBackVersion } from '../../config';
import {
    ConversationSnapshot,
    ConversationMessageSnapshot,
} from '../../models/CRM';
import api from '../api';

const getConversations = (): Promise<ConversationSnapshot[]> =>
    api.request<ConversationSnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/agent/ai/conversations`,
    });

const getConversationMessages = (
    conversationId: string,
    lastMessageId: string | null
): Promise<ConversationMessageSnapshot[]> =>
    api.request<ConversationMessageSnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/agent/ai/conversations/${conversationId}/messages`,
        params: {
            last_message_id: lastMessageId,
        },
    });

export default { getConversations, getConversationMessages };
